module.exports = __webpack_public_path__ + "static/media/AI-灯屏.0c8ff9ef.jpg";